// ** React Imports
import { useState, useEffect, useRef, Fragment } from 'react'
import { Button, UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from "reactstrap"
import CreateWorkorder from './CreateWorkorder'
import { useSelector } from "react-redux"
import { isUserLoggedIn } from '@utils'
import { useNavigate, useParams } from "react-router-dom"
import { Plus } from 'react-feather'

const NavbarCreate = () => {
  const stores = useSelector((state) => state.commonreducerSlice)
  const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn())?.isEmployee
  const { woId } = useParams()
  const navigate = useNavigate()

  const [open, setOpen] = useState(false)
  const container = useRef(null)
  const [catData, setCatData] = useState([])
  const [catValue, setCatValue] = useState(null)

  const [centeredModal, setCenteredModal] = useState(false)
  const [categoryId, setCategoryId] = useState(null)
  const [typeId, setTypeId] = useState(null)
  const [valid, setValid] = useState(false)

  const clsModel = (centeredModal) => {
    setCenteredModal(centeredModal)
  }

  useEffect(() => {
    setCatData([{ value: 1, label: 'Work Order' }])
  }, [])

  useEffect(() => {
    if (catValue === 1) {
      setCenteredModal(!centeredModal)
      setValid(false)
      setCatValue(null)
    } else if (catValue === 2) {
      if (isEmployee) {
        setValid(true)
        setCenteredModal(!centeredModal)
        setCatValue(null)
      } else {
        if (categoryId) {
          if (woId) {
            navigate('/pageRefresh')
            setTimeout(() => {
              navigate(`/${categoryId.code}/${typeId.code}/save`)
            }, 2000)
          } else {
            navigate(`/${categoryId.code}/${typeId.code}/save`)
          }
        }
        setCatValue(null)
        setValid(false)
      }
    }
  }, [catValue])


  const handleClickOutside = event => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      // clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  })

  const handleMouseEnter = () => {
    setOpen(true)
  }

  const handleMouseLeave = () => {
    setOpen(false)
  }

  return (
    <Fragment>
      <Button.Ripple color='primary' onClick={() => setCenteredModal(true)} style={{ marginRight: '24px' }}>
        <Plus size={14} className='' style={{ marginBottom: '3px' }} />
        <span className='align-middles mx-50'>Create</span>
      </Button.Ripple>
      {centeredModal && (
        <CreateWorkorder centerModal={centeredModal} closeModel={clsModel} categoryId={categoryId} typeId={typeId} valid={valid} />
      )}
    </Fragment>

  )
}

export default NavbarCreate